import React from 'react';
import { Link } from '../../utils/router/v3Bridge';
import useAppSelector from '../../app/redux/useAppSelector';
import MetaList, { MetaListItem } from '../../components/MetaList';
import Timestamp from '../../components/Timestamp';
import type { Scalars } from '../../graphql/generated/graphql';
import getFirstName from '../../utils/text/getFirstName';
import commentThreadHash from '../../utils/url/commentThreadHash';
import userPath from '../../utils/url/userPath';
import useIsPublicView from '../../utils/useIsPublicView';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const AUTHOR_FRAGMENT = gql(`
  fragment CommentAuthor_author on PublicUserFields {
    id
    name
    ...userPath_user
  }
`);

interface CommentAuthorProps {
  author: DocumentType<typeof AUTHOR_FRAGMENT>;
  isFirst?: boolean;
  isExpanded?: boolean;
  isHistorical?: boolean;
  insertedAt: Scalars['Datetime']['output'];
  threadId: string;
}

const CommentAuthor = ({
  author,
  isFirst = false,
  isExpanded = false,
  isHistorical = false,
  insertedAt,
  threadId,
}: CommentAuthorProps) => {
  const currentUser = useAppSelector((state) => state.session.user);
  const isPublicView = useIsPublicView();

  const name = currentUser.id === author.id ? 'You' : author.name;
  if (isExpanded || isHistorical) {
    return (
      <MetaList>
        <MetaListItem delimiter={null}>
          {isPublicView ? (
            <span className="name">{getFirstName(name)}</span>
          ) : (
            <Link className="name" to={userPath(author)}>
              {getFirstName(name)}
            </Link>
          )}
        </MetaListItem>
        <MetaListItem>
          {isFirst && !isHistorical ? (
            <a className="permalink" href={commentThreadHash(threadId)}>
              <span className="modified">
                <Timestamp date={insertedAt} />
              </span>
            </a>
          ) : (
            <span className="modified">
              <Timestamp date={insertedAt} />
            </span>
          )}
        </MetaListItem>
      </MetaList>
    );
  }
  return (
    <Link className="name" to={userPath(author)}>
      {name}
    </Link>
  );
};

export default CommentAuthor;
